/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = NEW
 *
 * 1 = USED
 *
 * 2 = DEMO
 */
export enum InventoryVehicleType {
  NEW = 0,
  USED = 1,
  DEMO = 2,
}
